import React from 'react';
import { PropTypes } from 'prop-types';
import { RowWrapper } from './styles';

const Row = ({ ala, original: { alaLevelsCount, inactiveAla } }) => (
  <RowWrapper ala={ala} inactiveAla={inactiveAla}>
    {alaLevelsCount[ala]}
  </RowWrapper>
);

Row.propTypes = {
  original: PropTypes.shape({
    alaLevelsCount: PropTypes.arrayOf(PropTypes.number),
    inactiveAla: PropTypes.arrayOf(PropTypes.number),
  }),
  ala: PropTypes.number,
};

export default ala => props => <Row ala={ala} {...props} />;
